import { render, staticRenderFns } from "./RoleDisplayView.vue?vue&type=template&id=306997e0"
import script from "./RoleDisplayView.vue?vue&type=script&lang=js"
export * from "./RoleDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports